import colors from 'assets/theme/base/colors';

export const getStatusColor = (status: string) => {
    switch (status) {
        case 'active':
            return colors.primary.light;
        case 'archive':
            return colors.error.main;
        case 'draft':
            return colors.action.draft;
        case 'empty':
            return colors.action.empty;
        case 'done':
            return colors.grey['400'];
        case 'cancel':
            return colors.grey['400'];
    }
};
